import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    isLoggedIn: false,
    authToken: ''
};
const authSlice = createSlice({
    name: 'auth',
    initialState: initialState,
    reducers: {
        setIsLoggedIn: (state, action) => {
            state.isLoggedIn = action.payload;
        },
        setAuthToken: (state, action) => {
            state.authToken = action.payload;
        },
    },
});

export const { setIsLoggedIn, setAuthToken } = authSlice.actions;
const authReducer = authSlice.reducer;
export default authReducer;
